const DATA_TEST_IDS = {
  cookiesCookieDialog: 'cookies__cookie-dialog',
  cookiesCookiesNote: 'cookies__cookies-note',
} as const;

export default DATA_TEST_IDS;
